<template lang="html">
  <h1>template test</h1>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
</style>
